import { useEffect, useCallback, useState, useMemo } from 'react'
import _ from 'lodash'

export default ({
  fetchIngredients, fetchFoodKinds, onChange, values, changeModel, onClose, model, multi,
  dontFetch, ingredients, groupItems, fetchIngredient, disabled, returnOriginals,
}) => {
  const [searchValue, setSearchValue] = useState('')
  const [foodKindsFetched, setFoodkindsFetched] = useState(false)

  useEffect(() => {
    (async () => {
      if(!foodKindsFetched) {
        await fetchFoodKinds()
        setFoodkindsFetched(true)
      }
      if(!dontFetch) {
        await fetchIngredients(0)
      }
    })()
  }, [dontFetch]) //eslint-disable-line react-hooks/exhaustive-deps

  const handleConfirm = useCallback(() => {
    (async () => {
      const originalIngredients = await Promise.all(values.map(v => fetchIngredient(v.id)))
      onChange(values.map( ingredient => ({
        ...(originalIngredients.find(i => i.id === ingredient.id)),
        ...(returnOriginals ? {} : ingredient),
      })))
    })()
  }, [fetchIngredient, onChange, returnOriginals, values])


  const delayedSearch = useMemo(() => {
    const searchItems = async searchValue => {
      await fetchIngredients(0, searchValue)
    }
    return _.debounce(searchItems, 1000)
  }, []) //eslint-disable-line react-hooks/exhaustive-deps

  const handleSearch = event => {
    setSearchValue(event.target.value)
    if(!dontFetch) {
      delayedSearch(event.target.value)
    }
  }

  const handleSelectItem = useCallback(event => {
    const id = parseInt(groupItems ? event.target.name.split(',')[0] : event.target.name, 10)
    const group = groupItems ? parseInt(event.target.name.split(',')[1], 10) : null
    const checkItem = item => groupItems ? item.id === id && item.section === group : item.id === id
    const ingredient = ingredients.find(checkItem)
    const selected = event.target.value
    changeModel({
      target: {
        name: 'values',
        value: selected ? multi ? [...values, ingredient] : [ingredient] : values.filter(v => v !== ingredient),
      },
    })
  },[changeModel, ingredients, multi, values, groupItems])

  const searchText = () => ({
    onChange: handleSearch,
    value: searchValue,
  })

  const actions = useMemo(() => {
    return [{
      title: 'Cancel',
      action: onClose,
      blue: true,
      outlined: true,
    }, {
      title: 'Confirm',
      action: handleConfirm,
      blue: true,
      disabled: !values || values.length === 0 || disabled,
    }]
  }, [disabled, handleConfirm, onClose, values])

  return {
    handleConfirm,
    handleSearch,
    handleSelectItem,
    searchText,
    actions,
    searchValue,
  }
}
